import React from 'react';
import {FastField} from 'formik';
import {Grid} from '@material-ui/core';
import {FormikErrors} from 'formik/dist/types';
import {IOfferDetailsProps, IPlaceDetails, IPredictionFormatted} from 'data/interfaces/products';
import EditorSection from '../../../../../commons/editor/components/editorSection';
import FormikRadioInput from 'gui/components/formikRadioInput/formikRadioInput';
import BaggageSelector from './components/baggageSelector/BaggageSelector';


export interface IHotel extends IPredictionFormatted, IPlaceDetails {
  postalCode: string;
}


const BaggageDetails = (props: { values: IOfferDetailsProps, submitCount: number, errors: FormikErrors<any>, setFieldValue: any }) => (
  <EditorSection title="כבודה">
    <Grid item xs={12} sm={6}>
      <FastField
        component={FormikRadioInput}
        label={"טרולי"}
        name="handBag"
        okMode
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <FastField
        component={BaggageSelector}
        label={"מזוודה"}
        name="baggage"
      />
    </Grid>
  </EditorSection>
);

BaggageDetails.defaultProps = {
  values: {},
  errors: [],
  submitCount: 0,
  setFieldValue: () => null,
};

export default React.memo(BaggageDetails);
